export const experienceData = [
    {
        id: 1,
        company: 'Young Cyber Knights Foundation',
        jobtitle: 'Backend Developer Intern | Remote',
        startYear: 'Oct 1',
        endYear: ' Nov 30, 2025'
    },
    {
    id: 2,
    company: "Learn and build something everyday.",
    jobtitle: "Self Employed",
    startYear: '2024',
    endYear: 'present'
  }
]